module.exports = __webpack_public_path__ + "img/Upscaler05.bc2f988c.png";